import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const check = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(false);
    }
  }, []);
  useEffect(() => {
    check();
    const h = () => setUser(false);
    window.addEventListener("auth:logout", h);
    return () => window.removeEventListener("auth:logout", h);
  }, [check]);
  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  const can = (p) => !!user && (user.permissions.includes("*") || user.permissions.includes(p));
  return <Ctx.Provider value={{ user, login, logout, can }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
